import * as React from 'react';
import Button from '../../../Button/Button';
import './SocialButton.css';

interface Props {
	type: 'google' | 'vk' | 'facebook';
	onClick: () => void;
	text: string;
}

const SocialButton: React.FunctionComponent<Props> = props => {
	return <Button className={`socialButton socialButton_${props.type}`} onClick={props.onClick}>
		<div className="socialButton__icon" />

		{props.text}
	</Button>;
};

export default SocialButton;
